export default __webpack_public_path__ + "static/media/interview.f4a7b899.jpg";